var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('van-popup', {
    style: {
      width: '80%',
      borderRadius: '4px 4px 0 0'
    },
    attrs: {
      "position": "center",
      "closeable": true
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, [_c('div', {
    staticClass: "image-popup"
  }, [_c('PreviewImage', {
    staticClass: "image-popup__image",
    "class": _vm.imageClass,
    attrs: {
      "src": _vm.src,
      "alt": ""
    }
  }), _c('div', {
    staticClass: "image-popup__tips"
  }, [_vm._v("长按图片保存到相册，分享给好友吧！")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };